import useTranslate from '@root/core/hooks/useTranslate';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { stateKorea } from '../../utils/Languages';
import SignUpDate from '../components/SignUpDate';
import Tabss from '../components/Tabss';
import busksellerdetail from '../services/busksellerdetail';

const BuskSellerDetail = () => {
  const [t] = useTranslate();
  const { id } = useParams<{ id: string }>();
  const [tabChange, setTabChange] = useState('1');
  const checkTabState = (tabChange: string) => {
    switch (tabChange) {
      case '1':
        return '셀러 상세';
      case '2':
        return '물류센터 계약 목록';
      case '3':
        return '상품 목록';
      case '4':
        return '배송 목록';
      case '5':
        return '반품 목록';
      case '6':
        return '폐기 목록';
      case '7':
        return '반환 목록';
      default:
        return '셀러 상세';
    }
  };
  const breadcrumbList = [
    {
      tittle: '셀러 관리',
      url: '/admin/busk/sellers'
    },
    {
      tittle: checkTabState(tabChange),
      url: ''
    }
  ];

  const handleTabChange = (key: string) => {
    setTabChange(key);
  };

  // seller detail
  const [formData, setFormData] = useState();
  // seller warehouse table detail
  const [rowDataWarehouse, setRowDataWarehouse] = useState();
  const [totalWarehouse, setTotalWarehouse] = useState(0);
  const [selectedWarehouse, setSelectedWarehouse] = useState<React.Key[]>([]);
  const [pageLogistic, setPageLogistic] = useState(1);

  // seller product detail
  const [rowDataProducts, setRowDataProducts] = useState();
  const [totalProduct, setTotalProduct] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState<React.Key[]>([]);
  const [pageProduct, setPageProduct] = useState(1);

  const [loading, setLoading] = useState(false);

  const getSellerDetail = async () => {
    const buskSellerDetail = await busksellerdetail.getSellerDetail(id);
    buskSellerDetail.data.state = stateKorea(buskSellerDetail.data.state);
    setFormData(buskSellerDetail.data);
  };

  const getWarehouseDetail = async (id: string, page: number) => {
    setLoading(true);
    const buskWarehouseDetail = await busksellerdetail.getWarehouseList(
      id,
      page
    );
    const rowDataModified = buskWarehouseDetail.data?.map(
      (r: any, index: number) => {
        return {
          ...r,
          key: r.productId,
          // no: index + (page - 1) * 10 + 1
          no: r.id
        };
      }
    );

    setRowDataWarehouse(rowDataModified);
    setTotalWarehouse(buskWarehouseDetail.count);
    setLoading(false);
  };

  const handleChangePageLogistic = (page: number) => {
    setPageLogistic(page);
  };
  const handleChangePageProduct = (page: number) => {
    setPageProduct(page);
  };

  const getProductList = async (id: string, page: number) => {
    setLoading(true);
    const buskProductList = await busksellerdetail.getProductList(id, page);
    const rowDataModified = buskProductList.data?.map(
      (r: any, index: number) => {
        return {
          ...r,
          key: r.id,
          // no: index + (page - 1) * 10 + 1
          no: r.id
        };
      }
    );

    setRowDataProducts(rowDataModified);
    setTotalProduct(buskProductList.count);
    setLoading(false);
  };

  useEffect(() => {
    getSellerDetail();
  }, []);

  useEffect(() => {
    getWarehouseDetail(id, pageLogistic);
  }, [pageLogistic]);

  useEffect(() => {
    getProductList(id, pageProduct);
  }, [pageProduct]);

  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="busk-container">
        <SignUpDate formData={formData} />
        <Tabss
          // tab change
          handleTabChange={handleTabChange}
          formData={formData}
          //warehouse
          getWarehouseDetail={getWarehouseDetail}
          rowDataWarehouse={rowDataWarehouse}
          totalWarehouse={totalWarehouse}
          handleChangePageLogistic={handleChangePageLogistic}
          //product
          getProductList={getProductList}
          rowDataProducts={rowDataProducts}
          totalProduct={totalProduct}
          loading={loading}
          //warehouse
          selectedWarehouse={selectedWarehouse}
          setSelectedWarehouse={setSelectedWarehouse}
          //product
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          handleChangePageProduct={handleChangePageProduct}
        />
      </div>
    </div>
  );
};

export default BuskSellerDetail;
